import { render } from "./ListImportsPage.vue?vue&type=template&id=fae669d6&ts=true"
import script from "./ListImportsPage.vue?vue&type=script&lang=ts"
export * from "./ListImportsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__